import onKeyboardArchive from '../actions/actionCreators/onKeyboardArchive';
import { orchestrator } from 'satcheljs';
import archiveMailListRows from 'owa-mail-triage-action/lib/actions/archiveMailListRows';
import moveItemsBasedOnNodeIds from 'owa-mail-triage-action/lib/actions/actionCreators/moveItemsBasedOnNodeIds';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { resetFocus } from 'owa-mail-focus-manager';

// Orchestrator for keyboard archive on both item parts and rows
export default orchestrator(onKeyboardArchive, actionMessage => {
    const { tableView, selectedNodeIds, selectedRowKeys } = actionMessage;

    // Is item part operation
    if (selectedNodeIds.length > 0) {
        moveItemsBasedOnNodeIds(
            selectedNodeIds,
            folderNameToId('archive'),
            tableView.id,
            'Keyboard'
        );
        resetFocus();
        //Is row operation
    } else {
        if (selectedRowKeys.length === 0) {
            return;
        }

        archiveMailListRows(selectedRowKeys, tableView, 'Keyboard');
    }
});
